export default __webpack_public_path__ + "static/media/a023-1.550429d3.png";